import { typeCheck } from './index';

export const resetObjFields = (obj, shallowCheck = []) => {
  return Object.keys(obj).reduce((acc, field) => {
    const value = obj[field];

    // short circuit evaluation for shallow check objects
    if (shallowCheck.includes(field) && typeCheck(value).isObj) return (acc[field] = null), acc;

    if (typeCheck(value).isObj) return (acc[field] = resetObjFields(obj[field])), acc;
    if (typeCheck(value).isArray) return (acc[field] = []), acc;
    if (typeCheck(value).isDate) return (acc[field] = new Date()), acc;
    if (typeCheck(value).isNum) return (acc[field] = 0), acc;
    if (typeCheck(value).isNull) return (acc[field] = null), acc;
    if (typeCheck(value).isString) return (acc[field] = ''), acc;
    if (typeCheck(value).isBoolean) return (acc[field] = false), acc;
    if (typeCheck(value).isFile) return (acc[field] = null), acc;
    return acc;
  }, {});
};
